export const interpreterPageStyles = {
  page: 'flex h-dvh overflow-hidden bg-background',
  content: 'flex min-w-0 flex-1 flex-col',
  main: 'min-h-0 flex-1 overflow-y-auto p-4 md:p-6',
  liveContainer: 'mx-auto w-full',
  liveHeader: 'mb-4 flex flex-wrap items-center justify-between gap-3 border-b pb-4',
  liveTitle: 'font-semibold text-lg',
  mutedCaption: 'text-muted-foreground text-xs',
  columns: 'grid gap-5 xl:grid-cols-[minmax(340px,1fr)_4px_minmax(300px,min(var(--summary-width),60%))]',
  resizeHandle: 'hidden cursor-col-resize bg-border transition-colors hover:bg-primary xl:block',
  summaryPanel:
    'h-[calc(100dvh-13rem)] min-h-[36rem] min-w-0 overflow-hidden border-border border-l bg-muted shadow-xl',
  error: 'mx-auto mt-4 max-w-3xl rounded-md border border-destructive/30 bg-destructive/10 p-3 text-destructive',
  setupCard: 'mx-auto mt-12 max-w-xl space-y-6 rounded-2xl border bg-card p-6 shadow-sm',
  setupTitle: 'font-semibold text-2xl',
  betaBadge: 'text-primary text-sm',
  description: 'mt-2 text-muted-foreground text-sm',
  field: 'space-y-2',
  fieldLabel: 'block font-medium',
  deviceHint: 'rounded-lg bg-muted p-3 text-sm',
  controlsCard: 'space-y-4 rounded-xl border bg-card p-4',
  phase: 'rounded-lg bg-primary/10 p-3 font-medium text-primary',
  actions: 'flex flex-wrap gap-2',
  modeRow: 'flex items-center gap-2 text-sm',
  compactSelect: 'py-2',
  settingsStack: 'space-y-3',
  settingsRow: 'flex items-center justify-between gap-3',
  settingLabel: 'text-sm',
  settingBlockLabel: 'block text-sm',
  conversationEmpty: 'py-12 text-center text-muted-foreground',
  turn: 'rounded-lg border p-3',
  turnHeading: 'font-medium text-sm',
  textOnly: 'font-normal text-muted-foreground',
  turnText: 'mt-1 whitespace-pre-wrap',
  translation: 'mt-3 border-t pt-2',
} as const;
